<template>
    <div class="uplevel">

        <div class="level flexbox  fle-sb" v-if="!isApp">
            <img src="../../assets/imgs/logo.png">
            <div class="flex2 texal padl linbor">
                <div>{{$t('account.hello')}} {{user.username}} ({{$t('account.balance2')}} {{user.money}}USDT)</div>
                <div v-if="user.grade_id">
                    <span class="active">vip</span>
                    <span class="colory">VIP{{user.grade_id}}</span>
                    <span style="padding-left: 40px">{{$t('account.time_remaining2')}}</span>
                    <span class="colory"> {{countDownTime}}</span>
                </div>
            </div>
        </div>
        <div class="acctit zi2" v-if="isApp">
            {{$t('account.vip_up_level')}}
            <div class="addbtn btnn">
                <el-popover placement="bottom" width="80" trigger="click">
                    <div class="lanlist">
                        <div :class="lang==item.name?'activeList':''" @click="changlang(item.name, item)"
                             v-for="(item, index) in langList" :key="index">
                            <img :src="item.flag"/>{{item.full_name}}
                        </div>
                    </div>
                    <div slot="reference"><img :src="currentLang.flag"/>{{currentLang.full_name}}</div>
                </el-popover>
            </div>
        </div>
        <div class="lelbox">
            <div class="leveltop" v-if="isApp">
                <div class="bgbl flexbox fle-sb">
                    <img src="../../assets/imgs/logo.png">
                    <div class="texal flex2 padl">
                        <div class="colory fontw">{{user.money}}</div>
                        <div>{{$t('account.balance')}}(USDT)</div>
                    </div>
                    <div class="texalr">
                        <div class="sma colory" v-if="user.grade_id"><i class="el-icon-medal-1"></i>VIP{{user.grade_id}}</div>
                        <div class="colory fontw posrbtn" v-if="!user.user_id" @click="$router.push({path: '/login'})">
                            {{$t('account.login')}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="leveltop" v-if="isApp && user.grade_id">
                <div class="bgbl flexbox fle-sb">
                    <div class="texalr">
                        <div class="hysytip2 " v-if="user.grade_id">
                            <i class="el-icon-medal-1"></i>{{$t('account.time_remaining2')}} <span class="colory">{{countDownTime}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="levecard flexbox fle-sb fle-wrap">
                <div v-for="(item, index) in lists" :key="index+'card'" class="btnn flexbox fle-ct carditem"
                     @click="chooseVip(item.id, item.grade_id, index)">
                    <div class="imgbox"><img :src="item.image"></div>
                    <div class="flex2 texal padl">
                        <div class="fontw title">VIP{{item.grade_id}}</div>
                        <div class="fontsm">{{$t('account.daily_money')}} {{item.daily_money}}</div>
                        <div class="fontsm">{{$t('account.month_money')}} {{item.month_money}}</div>
                    </div>
                    <div class="texalr padt2">
                        <div class="title">{{item.amount}}</div>
                        <div class="fontsm">{{$t('account.limit_days')}} {{item.days}}</div>
                    </div>
                    <div class="tip"><span class="nm">VIP{{item.grade_id}}</span><i
                            :class="['circlebor', index==currentIndex?'el-icon-check actived':'']"></i></div>
                </div>
            </div>
            <div class="formbox">
                <div class="colory" style="text-align: left;">{{$t('account.vip_remark')}}</div>
                <el-form :model="form" ref="form" label-width="110px" class="demo-ruleForm">

                    <el-form-item>

                    </el-form-item>
                    <el-form-item :label="$t('account.trader_password')">
                        <el-input prefix-icon="el-icon-key" type="password" v-model="form.pay_password"
                                  :placeholder="$t('account.input_trader_password')" autocomplete="off"></el-input>
                    </el-form-item>
                    <div class="btnn bgb" @click="submitForm()">{{$t('account.upgrade_now')}}</div>
                </el-form>
            </div>
        </div>


    </div>
</template>

<script>
    // @ is an alias to /src
    import Cookies from 'js-cookie'
    import {
        getList,
        upLevel
    } from '@/api/vip'

    export default {
        name: 'upLevel',
        data() {
            return {
                currentIndex: -1,
                lists: [],
                user: {
                    user_id: -1,
                    money: '0.00',
                    username: '',
                    grade_id: 0,
                },
                leftVipTime: '',
                countDownTime: '',
                countDownFn: null,
                form: {
                    id: 0,
                    grade_id: 0,
                    pay_password: ''
                },
                lang: Cookies.get('lang'),
                langList: [],
                currentLang: {},
            }
        },
        computed: {
            isApp() {
                return document.documentElement.clientWidth < 800 ? true : false
            },
            routeName() {
                console.log(this.$route.path)
                return this.$route.path
            }
        },
        created() {
            this.getData()
        },
        destroyed(){
            clearInterval(this.countDownFn); //清除定时器
        },
        methods: {
            returnpage() {
                this.$router.go(-1)
            },
            chooseVip(id, grade_id, index) {
                if (this.currentIndex != index) {
                    this.currentIndex = index
                    this.form.id = id
                    this.form.grade_id = grade_id
                }
            },
            getData() {
                getList().then(res => {
                    const data = res.data
                    this.lists = data.lists
                    this.user = data.user
                    this.langList = data.langList
                    if (this.langList) {
                        for (let index = 0; index < this.langList.length; index++) {
                            let item = this.langList[index]
                            if (this.lang == item.name) {
                                this.currentLang = item
                                break
                            }
                        }
                    }
                    this.leftVipTime = res.data.leftVipTime
                    if(this.leftVipTime){
                        this.countDown()
                    }
                }).catch(_ => {

                })
            },
            countDownFun(time) {
                // console.log(time)
                let startTime = new Date(); //当前时间
                let end = new Date(time); //结束时间
                // console.log(end)
                let result = parseInt((end - startTime) / 1000); //计算出豪秒
                let d = parseInt(result / (24 * 60 * 60)); //用总共的秒数除以1天的秒数
                let h = parseInt((result / (60 * 60)) % 24); //精确小时，用去余
                let m = parseInt((result / 60) % 60); //剩余分钟就是用1小时等于60分钟进行趣余
                let s = parseInt(result % 60);
                //当倒计时结束时，改变内容
                if (result <= 0) {
                    return 0
                }
                if (h < 10) {
                    h = "0" + h
                }
                if (m < 10) {
                    m = "0" + m
                }
                if (s < 10) {
                    s = "0" + s
                }
                if (h == 0 && m == 0) {
                    return s + "s"
                } else if (h == 0) {
                    return m + ":" + s
                } else if (d == 0) {
                    return h + ":" + m + ":" + s
                } else {
                    if(d > 1){
                        return d + this.$t('account.days') + h + ":" + m + ":" + s
                    }else{
                        return d + this.$t('account.day') + h + ":" + m + ":" + s
                    }
                }
            },

            // 定时器
            countDown() {
                let that = this;
                that.countDownFn = setInterval(() => {
                    //  console.log(that.countDownFun(item.leftVipTime))
                    let html = that.countDownFun(that.countDownTime)
                    if (html === 0) {
                        that.leftVipTime = ''
                        clearInterval(that.countDownFn); //清除定时器
                        that.getData()
                    } else {
                        that.countDownTime = that.countDownFun(that.leftVipTime)
                    }
                }, 1000)
            },
            changlang(lang, item) {
                if (lang != this.lang) {
                    this.lang = lang
                    this.currentLang = item
                    this.$i18n.locale = lang
                    Cookies.set('lang', lang)
                    Cookies.set('lang_var', item.lang_var)
                    this.$router.go(0)
                }
            },
            submitForm() {
                if (this.form.id == 0) {
                    this.$message.error(this.$t('account.select_vip_level'))
                    return false
                }
                if (this.form.grade_id <= this.user.grade_id) {
                    this.$message.error(this.$t('account.select_higher_vip_level'))
                    return false
                }
                if (this.form.pay_password == "") {
                    this.$message.error(this.$t('account.input_your_trader_password'))
                    return false
                }
                this.submit()
            },
            submit() {
                let params = {
                    ...this.form
                }
                let that = this
                upLevel(params).then(res => {
                    if (res.code == 1) {
                        that.$alert(res.msg, that.$t('account.trader_tips'), {
                            confirmButtonText: that.$t('account.trader_confirm'),
                            customClass: 'message-logout',
                            callback: action => {
                                that.form.pay_password = ''
                                that.getData()
                            }
                        });
                        /* this.$message.success(res.msg)
                        setTimeout(function() {
                          that.form.pay_password = ''
                          that.getData()
                        }, 1000); */
                    } else if (res.code == 2) {
                        that.$alert(res.msg, that.$t('account.trader_tips'), {
                            confirmButtonText: that.$t('account.trader_confirm'),
                            customClass: 'message-logout',
                            callback: action => {
                                that.form.pay_password = ''
                                that.getData()
                            }
                        });
                        /* this.$message.error(res.msg)
                        setTimeout(function() {
                          that.form.pay_password = ''
                          that.getData()
                        }, 1000); */
                    } else {
                        that.$alert(res.msg, that.$t('account.trader_tips'), {
                            confirmButtonText: that.$t('account.trader_confirm'),
                            customClass: 'message-logout'
                            /* callback: action => {
                              that.form.pay_password = ''
                              that.getData()
                            } */
                        });
                        //this.$message.error(res.msg)
                    }

                }).catch(_ => {

                })

            },
        }
    }
</script>
<style lang="scss" scoped>
    .uplevel {
        width: 1200px;
        margin: 30px auto;
        color: #fff;
        background: #2a2a2a;
        border-radius: 20px;
        padding: 30px 40px;
        box-sizing: border-box;

        .level {
            line-height: 40px;
            font-size: 20px;

            img {
                width: 100px;
                height: 100px;
                border-radius: 100%;
            }
        }

        span.active {
            color: #1750cc;
            padding: 2px 0px;
            margin-right: 10px;
            border-top: 2px solid #1750cc;
            border-bottom: 2px solid #1750cc;
        }

        .acctit {
            border-bottom: 0px;
            background: #000;

            .addbtn {
                background: #000 !important;
            }

            img {
                width: 30px;
                height: 20px;
                vertical-align: middle;
                margin-right: 6px;
            }
        }

        .carditem {
            margin: 20px 0px;
            width: 45%;
            border-radius: 20px;
            padding: 30px 30px;
            color: #fff;
            box-sizing: border-box;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            position: relative;

            .imgbox {
                img {
                    width: 60px;
                    height: 60px;
                    border-radius: 100%;
                }
            }

            &:nth-child(1) {
                background: rgb(199, 107, 79);
                box-shadow: 0 2px 12px 0 rgba(199, 107, 79, 0.3);

            }

            &:nth-child(2) {
                background: rgb(195, 205, 209);
            }

            &:nth-child(3) {
                background: rgb(235, 174, 63);
            }

            &:nth-child(4) {
                background: rgb(169, 217, 240);
            }

            &:nth-child(5) {
                background: #ffd700;
            }


            .title {
                font-size: 24px;
                line-height: 40px;
            }

            .texalr {
                text-align: right;
            }

            .padt2 {
                padding-top: 30px;
            }

            .fontsm {
                font-size: 14px;
                line-height: 30px;
            }

            .tip {
                position: absolute;
                right: 80px;
                top: 10px;

                .nm {
                    line-height: 24px;
                }
            }

            .circlebor {
                position: absolute;
                border-radius: 100%;
                margin-left: 30px;
                width: 20px;
                height: 20px;
                border: 1px solid #fff;

                &.actived {
                    border-color: #1750cc;
                    color: #1750cc;
                }
            }

        }

        .formbox {
            width: 60%;
            margin: 40px auto;

            .bgb {
                background: #1750cc;
                padding: 20px 30px;
                border-radius: 10px;
                width: 62%;
                margin: 30px auto;
                font-size: 20px;
            }
        }
    }
</style>
<style>
    @media (max-width: 730px) {
        .message-logout {
            width: 92% !important;
        }
    }
</style>
